// dwaar/src/lib/brand.js
// Repo: terralekha-core | Folder: dwaar/src/lib/
// Dwaar — TERRALEKHA brand constants. Mirrors the Python constants in CLAUDE.md.
// Never change these without a docs-level brand review.

export const TL_GOLD = "#CBA56A";         // Archive Gold
export const TL_EARTH_DEEP = "#1A1C1E";   // Primary dark surface
export const TL_STONE_LIGHT = "#F4F1ED";  // Light surface
export const TL_FONT_HEAD = "'Playfair Display', serif";
export const TL_FONT_BODY = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";

// Wordmark — always all-caps. PassPort — always capital P, capital P.
export const BRAND_NAME = "TERRALEKHA";
export const PASSPORT_LABEL = "PassPort";

// Public-facing generic error — reveal doctrine.
export const PUBLIC_ERROR = "An error occurred. Contact support@terralekha.in";
